import classNames from "classnames";
import StarRating from "components/rating/star-rating";
import { Context } from "context/context";
import { useContext } from "react";
import { btnCorner, sanitizeValueHTML } from "utils/constant";
import HeaderExample from "./component/header";

const showDummy = ["template", "content"];

export default function CouponsTab({ popup }) {
  const { view, selectedTab } = useContext(Context);
  const mobile = view === "mobile";
  const show = showDummy.includes(selectedTab);
  const data = popup.template_content && JSON.parse(popup.template_content);

  return (
    <div
      className={!mobile ? "p-[25px]" : ""}
      style={{
        marginBottom: mobile ? "50px" : "0",
        height: mobile ? "auto" : "635px",
      }}
    >
      <HeaderExample data={data} popup={popup} show={show} />
      {/* icons */}
      <div className="pt-6 text-[8px]">
        {/*  */}
        {(data?.coupons || []).map((obj, index) => {
          const hasDescription =
            obj.description && obj.description.trim() !== "<p></p>";
          const hasMiddleColumn = hasDescription || obj.termsText || show;
          const hasContent =
            hasDescription ||
            obj.title ||
            obj.subtitle ||
            obj.code ||
            obj.expiryText ||
            obj.termsText ||
            obj.termsLink;
          return (
            <div
              key={index}
              className={classNames(
                !obj.enabled && "hidden",
                mobile
                  ? "flex flex-col gap-2"
                  : "gap-4 items-center justify-between grid grid-cols-3",
                "border-2 border-tabBorder border-dashed mb-4 rounded-2xl w-full p-4 break-words"
              )}
              style={{
                borderColor: hasContent
                  ? popup?.element_colour || "#000000"
                  : "",
                borderRadius:
                  popup?.button_corner_style === "rounded"
                    ? "16px"
                    : btnCorner(popup?.button_corner_style),
              }}
            >
              <div className={hasMiddleColumn ? "col-span-1" : "col-span-2"}>
                {(obj.title || show) && (
                  <div
                    className={classNames(
                      "text-sm leading-4 text-secondary font-bold mb-2",
                      !obj?.title && "text-tabBorder"
                    )}
                    style={{
                      color: obj?.title
                        ? popup?.element_colour || "#000000"
                        : "",
                    }}
                  >
                    {obj.title || "50% Off"}
                  </div>
                )}
                {(obj.subtitle || show) && (
                  <div
                    className={classNames(
                      "font-bold uppercase leading-2",
                      !obj?.subtitle && "text-tabBorder"
                    )}
                  >
                    {obj.subtitle || "Your next purchase"}
                  </div>
                )}
              </div>
              {hasMiddleColumn && (
                <div className="flex flex-col justify-between gap-2 min-w-[30%]">
                  {(hasDescription || show) && (
                    <div
                      className={classNames(
                        "leading-2",
                        !hasDescription && "text-tabBorder"
                      )}
                      dangerouslySetInnerHTML={{
                        __html: hasDescription
                          ? sanitizeValueHTML(obj.description)
                          : "Coupon cannot be used in conjunction with any other offer.",
                      }}
                    />
                  )}
                  {(obj.termsText || show) && (
                    <div
                      className={classNames(
                        !obj?.termsText && "text-tabBorder"
                      )}
                      style={{
                        color: obj?.termsText
                          ? popup?.element_colour || "#000000"
                          : "",
                      }}
                    >
                      {obj.termsLink ? (
                        <span className="underline cursor-pointer">
                          {obj.termsText}
                        </span>
                      ) : (
                        obj.termsText || "Terms and Conditions Apply"
                      )}
                    </div>
                  )}
                </div>
              )}
              {(obj.code || obj.expiryText || show) && (
                <div className="min-w-[30%] flex flex-col justify-center items-center gap-2">
                  {(obj.code || show) && (
                    <div
                      className={classNames(
                        "w-full text-center text-xxs uppercase font-bold border-2 border-tabBorder border-dashed rounded-full p-2 overflow-hidden relative",
                        !obj?.code && "text-tabBorder"
                      )}
                      style={{
                        color: obj?.code
                          ? popup?.element_colour || "#000000"
                          : "",
                        borderColor: hasContent
                          ? popup?.element_colour || "#000000"
                          : "",
                        borderRadius: btnCorner(popup?.button_corner_style),
                      }}
                    >
                      {!show && (
                        <div
                          className="absolute top-0 bottom-0 right-4 left-0 flex items-center justify-center"
                          style={{
                            color: popup?.element_text_colour || "#FFFFFF",
                            backgroundColor: popup?.element_colour || "#000000",
                            borderRadius: btnCorner(popup?.button_corner_style),
                          }}
                        >
                          <div>Reveal Code</div>
                        </div>
                      )}
                      {obj.code || "50OFF"}
                    </div>
                  )}
                  {(obj.expiryText || show) && (
                    <div
                      className={classNames(
                        "text-center max-w-[85px]",
                        !obj?.expiryText && "text-tabBorder"
                      )}
                    >
                      {obj.expiryText || "Expires 01/01/20XX"}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {data.testimonialEnabled && (
        <div className="pt-5">
          {show || data.testimonialRating ? (
            <StarRating value={data.testimonialRating} />
          ) : null}
          <div
            className={`${
              show || data.testimonialContent ? "pt-3" : ""
            } text-sm ${!data?.testimonialContent && "text-tabBorder"}`}
          >
            {data?.testimonialContent ||
              (show &&
                "“Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt.”")}
          </div>
          <div className="pt-1">
            <p
              className={`text-13 font-bold ${
                !data?.testimonialAuthor && "text-tabBorder"
              }`}
            >
              {data?.testimonialAuthor || (show && "Jane Doe")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
